import { render, staticRenderFns } from "./QAList.vue?vue&type=template&id=8100b902&scoped=true"
import script from "./QAList.vue?vue&type=script&lang=js"
export * from "./QAList.vue?vue&type=script&lang=js"
import style0 from "./QAList.vue?vue&type=style&index=0&id=8100b902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8100b902",
  null
  
)

export default component.exports